import React, { useState } from 'react';
import styled from 'styled-components';
import { Filter, Group, Medicine } from '../components';
import { Container, Button } from '@material-ui/core';

const medicines = [
  { product: 'Giotrif', name: 'Giotrif®', activeIngredient: 'Afatinib' },
  { product: 'Glyxambi', name: 'Glyxambi® 10/5mg', activeIngredient: 'Linagliptina e Empagliflozina' },
  { product: 'Glyxambi', name: 'Glyxambi® 25/5mg', activeIngredient: 'Linagliptina e Empagliflozina' },
  { product: 'Jardiance', name: 'Jardiance® 25mg', activeIngredient: 'Empagliflozina' },
  { product: 'Jardiance', name: 'Jardiance® 10mg', activeIngredient: 'Empagliflozina' },
  { product: 'Jardiance DUO', name: 'Jardiance DUO® 12,5mg/850mg', activeIngredient: 'Empagliflozina e Cloridrato de Metformina' },
  { product: 'Jardiance DUO', name: 'Jardiance DUO® 12,5mg/1000mg', activeIngredient: 'Empagliflozina e Cloridrato de Metformina' },
  { product: 'Micardis HCT', name: 'Micardis® HCT 40/12,5mg', activeIngredient: 'Telmisartana e Hidroclorotiazida' },
  { product: 'Micardis HCT', name: 'Micardis® HCT 80/12,5mg', activeIngredient: 'Telmisartana e Hidroclorotiazida' },
  { product: 'Micardis HCT', name: 'Micardis® HCT 80/25mg', activeIngredient: 'Telmisartana e Hidroclorotiazida' },
  { product: 'Ofev', name: 'Ofev®', activeIngredient: 'Nintedanib' },
  { product: 'Spevigo', name: 'Spevigo®', activeIngredient: 'Espesolimabe' },
  { product: 'Spiolto', name: 'Spiolto®', activeIngredient: 'Brometo de Tiotrópio Monoidratado e Cloridrato de Olodaterol' },
  { product: 'Spiriva', name: 'Spiriva®', activeIngredient: 'Brometo de Tiotrópio e Brometo de Tiotrópio Monoidratado' },
  { product: 'Trayenta', name: 'Trayenta®', activeIngredient: 'Linagliptina' },
];

const Title = styled.h2`
  font-family: Roboto;
  font-weight: bold;
  line-height: 32.17px;
  text-align: left;
  margin-bottom: 20px;
  gap: 24px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 25px;
  }
`;

const HorizontalLine = styled.hr`
  border: none;
  height: 3px;
  background-color: #F3F3F4;
  opacity: 1;
`;

interface Groups {
  [letter: string]: Medicine[];
}

export default function MedicineLeafletsPage(): JSX.Element {
  const [filter, setFilter] = useState('');
  const [activeLetter, setActiveLetter] = useState('');

  // Apply the text filter first.
  const textFilteredMedicines = medicines.filter((medicine) =>
    medicine.name.toLowerCase().includes(filter.toLowerCase()),
  );

  // Compute available letters from the text medicines.
  const availableLetters = Array.from(new Set(medicines.map(
    (medicine) => medicine.name[0].toUpperCase(),
  ))).sort();

  // Apply the letter filter if active.
  const finalMedicines = activeLetter
    ? textFilteredMedicines.filter(
        (medicine) => medicine.name[0].toUpperCase() === activeLetter,
      )
    : textFilteredMedicines;

  const groupedMedicines = finalMedicines.reduce<Groups>((acc, medicine) => {
    const letter = medicine.name[0].toUpperCase();
    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(medicine);
    return acc;
  }, {});

  return (
    <>
      <Container>
        <Title>
          Bulário de A a Z
        </Title>
        <HorizontalLine />
        <Filter
          filter={filter}
          setFilter={setFilter}
          availableLetters={availableLetters}
          setActiveLetter={setActiveLetter}
          activeLetter={activeLetter}
        />
        
        {Object.keys(groupedMedicines).sort().map((letter) => (
          <div key={letter}>
            <Group letter={letter} medicines={groupedMedicines[letter]} />
          </div>
        ))}
      </Container>
    </>
  );
}
